import MenuItemSkeleton from "./MenuItemSkeleton";

export default MenuItemSkeleton;
